import React, { useState, useEffect } from 'react';
import { Menu, Avatar, Dropdown, Spin } from 'antd';
import { UserOutlined, LogoutOutlined } from '@ant-design/icons';
import styles from './index.module.scss';
import { getUserProfile } from '../../../api/user';
import { AxiosResponse, AxiosError } from 'axios';
import { UserInfo } from '../../../types/user';
import { logout } from '../../../api/login';
import Logo from '../Logo';
import { ApiResponse } from '../../../types';
import { useTranslation } from 'react-i18next';

const Navbar = () => {
  const [userInfo, setUserInfo]   = useState<UserInfo | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [error, setError]         = useState<string | null>(null);
  const { t } = useTranslation()

  const fetchUserInfo = async () => {
    setIsLoading(true);
    setError(null);
    try {
      const res: AxiosResponse<ApiResponse<UserInfo>> = await getUserProfile();
      if (res.data.status === 200) {
        setUserInfo(res.data.data);
      }
    } catch (err: unknown) {
      if (err instanceof Error) {
        setError(err.message || 'An error occurred');
      }
      
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchUserInfo();
  }, []);

  const handleLogout = () => {
    logout({}).then(() => {
      localStorage.removeItem('access_token');
      localStorage.removeItem('refresh_token');
      window.location.href = '/';
    })
  };

  const userMenu = (
    <Menu className={styles.dropdownMenu}>
      {isLoading ? (
        <div className={styles.loadingContainer}>
          <Spin />
        </div>
      ) : error ? (
        <div className={styles.errorContainer}>{error}</div>
      ) : userInfo ? (
        <>
          <div className={styles.profileHeader}>
            <Avatar size={64} icon={<UserOutlined />} src={userInfo?.avatarUrl} className={styles.avatarLarge} />
            <div className={styles.profileInfo}>
              <h3>{userInfo.nickname}</h3>
              <p></p>
            </div>
          </div>
          
        </>
      ) : (
        <div className={styles.errorContainer}>No user data available</div>
      )}
      <Menu.Item key="logout" icon={<LogoutOutlined />} className={styles.menuItem} onClick={handleLogout}>
        {t('logout_text')}
      </Menu.Item>
    </Menu>
  );

  return (
    <div className={styles.navbar}>
      <Logo />
      <Menu mode="horizontal" className={styles.menu}>
        <Menu.Item key="products" className={styles.menuItem}></Menu.Item>
        <Menu.Item key="pricing" className={styles.menuItem}></Menu.Item>
        <Menu.Item key="contact" className={styles.menuItem}></Menu.Item>
      </Menu>
      <div className={styles.userInfo}>
        <Dropdown 
          overlay={userMenu} 
          placement="bottomRight" 
          arrow 
          trigger={['hover']}
        >
          <Avatar size="large" icon={<UserOutlined />} className={styles.avatar} />
        </Dropdown>
      </div>
    </div>
  );
};

export default Navbar;